module.exports = __webpack_public_path__ + "img/bar-chart-04.433a0530.svg";